export enum SessionStorageKey {
  ConfirmationToken = 'confirmation_token',
  IsEsiaTransferSuccess = 'is_esia_transfer_success',
  OpenMainFamilyProfile = 'open_main_family_profile',
  RequireEsia = 'require_esia',
  EsiaAction='esia_action',
}
